import {
  createArenaContext,
  getStateBasedRoutes,
} from "../../layouts/arena-layout/createArenaContext";

export const getDecksArenaContext = ({history}) =>
  createArenaContext({
    type: "library",
    shortcutCategory: "Deck overview",
    model: null,
    routes: getStateBasedRoutes({rootPath: "/decks", rootUrl: "/decks", history}),
  });
